import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../shared.service';

@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.css']
})
export class QrcodeComponent implements OnInit {
  showTable = false;
  producerInfo;
  partnersInfo: any = [];
  showProducerEpcDid = false;
  showPartnersEpcDid: any = [];

  constructor(private service: SharedService, private router: Router) { }

  ngOnInit(): void {
    this.getData();
  }

  routeToSgtin(sgtin) {
    // console.log(sgtin);
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate(['/vis', {sgtin: 'urn'+sgtin.split('did')[1]}]);
    });
}

  getData = () => {
    this.service.getProducerInfo().subscribe(data => {
      this.producerInfo = data;
      // console.log(this.producerInfo);
      this.service.getPartnersInfo().subscribe(data => {
        this.partnersInfo = data;
        this.showPartnersEpcDid = new Array(this.partnersInfo.length).fill(false);
      })
    })
  }

  resolveSource = () => {
    this.showTable = this.showTable == false ? true : false;
  }

  displayProducerEpcDid = () => {
    this.showProducerEpcDid = true;
  }

  displayPartnersEpcDid = (i: number) => {
    this.showPartnersEpcDid[i] = true;
  }
  
}
